
<div id="mi-modal" class="modal-overlay">
  <div class="modal-content">

    <div class="modal-header">
        <p>{{ data.name }} </p>
        <span class="close-button" (click)="close()">&times;</span>
      
    </div>

    <div class="modal-body">
        <file-show-view
            [tab]="data"
        ></file-show-view>
    </div>
  </div>
</div>